import {
  LibraryRouteParams,
  ProjectRouteParams,
  urlStructureFavoriteOverview,
  urlStructureLibrary,
  urlStructureProject,
  urlStructureProjectsOverview,
  urlStructureProjectTemplatesProject,
  urlStructureTrashbin
} from '../../../../routing/routingPaths';
import { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

export const useVisitingPathParams = () => {
  const location = useLocation();

  const matchedProject = matchPath<ProjectRouteParams>(location.pathname, {
    path: urlStructureProject
  })?.params;

  const matchedProjectTemplate = matchPath<ProjectRouteParams>(
    location.pathname,
    {
      path: urlStructureProjectTemplatesProject
    }
  )?.params;

  const matchedLibrary = matchPath<LibraryRouteParams>(location.pathname, {
    path: urlStructureLibrary
  });

  const inProjectsOverview = matchPath(
    location.pathname,
    urlStructureProjectsOverview
  )?.isExact;

  const inFavoritesOverview = matchPath(
    location.pathname,
    urlStructureFavoriteOverview
  )?.isExact;

  const inBinOverview = matchPath(
    location.pathname,
    urlStructureTrashbin
  )?.isExact;

  const inLibraryRoot = matchedLibrary && matchedLibrary.isExact;

  const workspaceId =
    matchedLibrary?.params.workspaceId || matchedProject?.workspaceId;

  return useMemo(
    () => ({
      workspaceId,
      libraryId: matchedLibrary?.params.libraryId,
      projectId: matchedProject?.projectId || matchedProjectTemplate?.projectId,
      inLibraryRoot,
      inProjectsOverview,
      inFavoritesOverview,
      inBinOverview
    }),
    [
      inLibraryRoot,
      matchedLibrary,
      matchedProject,
      workspaceId,
      inProjectsOverview,
      inFavoritesOverview,
      inBinOverview
    ]
  );
};
